// Maps a file path to the appropriate CodeMirror language extension for syntax
// parsing. Returns null for unrecognized file types.
import { javascript } from "@codemirror/lang-javascript";
import { json } from "@codemirror/lang-json";
import { python } from "@codemirror/lang-python";
import { StreamLanguage } from "@codemirror/language";
import { dockerFile } from "@codemirror/legacy-modes/mode/dockerfile";
import { mbox } from "@codemirror/legacy-modes/mode/mbox";
import { shell } from "@codemirror/legacy-modes/mode/shell";
import type { Extension } from "@codemirror/state";
import { tags } from "@lezer/highlight";

// Remap mbox's token names onto the tags our highlight theme already styles.
const emlLanguage = StreamLanguage.define({
  ...mbox,
  tokenTable: {
    atom: tags.keyword,
    header: tags.string,
    link: tags.string,
  },
});

export function getLanguageExtension(filePath: string): Extension | null {
  if (filePath.endsWith(".py")) return python();
  if (filePath.endsWith(".tsx"))
    return javascript({ jsx: true, typescript: true });
  if (filePath.endsWith(".ts")) return javascript({ typescript: true });
  if (filePath.endsWith(".json")) return json();
  if (filePath.endsWith(".sh")) return StreamLanguage.define(shell);
  if (filePath.endsWith(".eml")) return emlLanguage;
  if (filePath.endsWith("Dockerfile")) return StreamLanguage.define(dockerFile);
  return null;
}
